import * as React from "react";
import { findDOMNode } from "react-dom";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import { IPanelContext } from "src/engine/context/PanelContext";
import UIManifest from "src/engine/ui/UIManifest";
import { Tabs as AntTabs } from "antd-mobile";
import IUIItem from "src/engine/interface/IUIItem";
import Utils from "src/lib/utils/Utils";
import "./Tabs.scss";
import Loading from "./Loading";
import Manifest from "src/engine/Manifest";
import Style from "src/lib/utils/Style";

interface ITabs extends IBaseUI {
    isData: boolean;
    titleStrs?: string;
    changeSource?: string;
    titlePath?: string;
    tabBar: IUIItem[];
    tabBarChoice: IUIItem[];
    dataListMap?: any;
    tabBarSize?: number;
    hideTabMap?: any; //隐藏标题map映射
    loadingUI: IUIItem[];
    typeId: string;
    defaultTab: number;
    tabDefaultStyle: any; //tab栏的样式
    tabBarBoxStyle: any; // tab栏的样式
    // tabBarUnderlineStyle: any;
    changeData?: any;
    useMouseHover?: boolean;
    distanceToChangeTab?: string;
    itemListBoxStyle?: any;
}

@UIManifest.declare("Tabs", "Tabs组件", UIManifest.Type.Mobile, false)
class Tabs extends BaseUI<ITabs> {
    state = {
        changeLoading: "",
        tabs: [],
        curAjax: "",
    };

    constructor(props: ITabs) {
        super(props);
        console.log("[Tabs]", "ssssssprops,", props, props.defaultTab);
        this.state = this.getState(props);
    }

    getState({ typeId = "typeId", defaultTab = 0 }: ITabs): any {
        const tabs = this.getTabs();
        const tab = tabs[defaultTab] || {};
        return {
            tabs,
            changeLoading: tab[typeId] || "",
        };
    }

    removeMouseEnterEvent: any;

    componentDidMount() {
        const { tabs } = this.state;
        const { defaultTab = 0, useMouseHover = false } = this.props;
        if (defaultTab < tabs.length) this.onTabClick(tabs[defaultTab], defaultTab);
        if (!useMouseHover) return;
        const tab: any = findDOMNode(this.tabsRef);
        // 查看了antd、antd-mob、rc-tabs等组件源码都不暴露切换函数，这样通过dom操作是最快的方式了
        if (!tab) return;
        const removeList: any = [];
        const bar = tab.querySelectorAll(".am-tabs-default-bar-tab");
        for (const item of bar) {
            const fn = (e: any) => {
                item.click();
            };
            item.addEventListener("mouseenter", fn, false);
            removeList.push(() => {
                item.removeEventListener("mouseenter", fn, false);
            });
        }
        this.removeMouseEnterEvent = () => {
            for (const fn of removeList) {
                fn();
            }
        };
    }

    childComponentWillUnmount() {
        if (this.removeMouseEnterEvent) this.removeMouseEnterEvent();
    }

    renderContent = (context: IPanelContext, tab: any) => {
        const { children = [], dataListMap = [], loadingUI, typeId = "typeId", itemListBoxStyle } = this.props;
        let uiItem = children[0],
            props = {};
        if (tab.info) {
            uiItem = tab;
        } else if (dataListMap.length > 1) {
            //如果多个数据源的处理
            props = tab;
        } else {
            props = { data: tab };
        }

        const { changeLoading, curAjax } = this.state;
        if (changeLoading === tab[typeId] && changeLoading !== curAjax) {
            //记录当前的ajaxID，避免快速操作覆盖数据
            if (!loadingUI || loadingUI.length === 0) {
                return <Loading uiItem={Manifest.ui()} />;
            }
            return this.renderChildren(loadingUI);
        }
        return <div style={Style(itemListBoxStyle)}>{this.renderUIItems([uiItem], context, props)}</div>;
    };

    renderTabBar = (context: IPanelContext, props: any) => {
        const { tabBar = [], tabBarSize = 3, tabBarChoice = [], titlePath = "info.cname", tabBarBoxStyle = {} } = this.props;
        const value = titlePath.split(".");
        return (
            <div className="tab-bar-wtf" style={Style(tabBarBoxStyle)}>
                <AntTabs.DefaultTabBar
                    {...props}
                    swipeable={false}
                    page={tabBarSize}
                    tabBarBackgroundColor={"transparent"}
                    renderTab={(tab: any) => {
                        if (!tab) return null;
                        let name = Utils.getValue(tab, value);
                        const choice = props.tabs.indexOf(tab) === props.activeTab;
                        if (tabBar.length > 0) {
                            const uiItem = choice && tabBarChoice[0] ? tabBarChoice[0] : tabBar[0];
                            let res = { data: tab, onMouseEnter: this.onMouseEnter };
                            if (tab.info) {
                                //对于多个独立tab,传value是index
                                res = { data: { value: props.tabs.indexOf(tab), cname: tab.info.cname }, onMouseEnter: this.onMouseEnter };
                            }
                            return this.renderUIItem(uiItem, context, res);
                        }
                        name = tab.title || name;
                        return (
                            <div className={`tab-item ${choice}`} onMouseEnter={this.onMouseEnter}>
                                {name}
                            </div>
                        );
                    }}
                />
            </div>
        );
    };
    onMouseEnter = () => {
        console.log(666);
    };
    getTabs = () => {
        const { dataSource, data, children, isData, dataListMap = [] } = this.props;
        if (dataListMap.length > 0) {
            //增加多个数据源的数据处理,manager
            const resArr: any[] = [];
            dataListMap.forEach((item: any, index: number) => {
                resArr.push({
                    dataSource: item.value || "",
                    source: item.source || "",
                    title: item.label,
                });
            });
            return resArr;
        }

        if (isData) {
            const item = Array.isArray(data) ? data : [];
            return dataSource ? (dataSource.data ? dataSource.data : dataSource) : item || [];
        }

        return children || []; //多个独立tab
    };

    onTabClick = (tab: any, index: number) => {
        const { source, changeSource = "", typeId = "typeId", changeData, uiItem } = this.props;
        if (source) {
            this.setState({ changeLoading: tab[typeId] });
            this.sourceContext.execSource(
                source,
                { start: 1, typeId: tab[typeId] },
                (ret) => {
                    this.setState({ curAjax: tab[typeId] });
                },
                {}
                // 300
            );
        }
        if (changeSource) {
            if (tab && tab.typeId === -1) {
                tab = {};
            }
            let props = {};
            if (changeData && changeData.length > 0) {
                // tab = {};
                changeData.map((item: any) => {
                    if (tab[item.label] !== undefined) {
                        props[item.value] = tab[item.label] + "";
                    }
                });
            } else {
                props = tab;
            }
            this.sourceContext.execSource(changeSource, props);
        }
        if (this.pageContext) {
            let msg = `${uiItem.info.ename}_tabs_click_${index}`;
            if (tab && tab.info && tab.info.cname) {
                msg = tab.info.cname;
            }
            this.pageContext.stat({ clickId: msg });
        }
    };
    getIsHide() {
        const { hideTabMap = [], data = {} } = this.props;
        for (const item of hideTabMap) {
            const list = item.label.split(".");
            let value = data || this.getIntent();
            const intent = this.getIntent() || {};
            list.map((key: string) => {
                if (value !== undefined && value !== null) value = data[key] || intent[key];
            });
            if (Utils.compare(item.type, value, item.value)) {
                return "hide";
            }
        }
        // const { pageLast } = this.props["pageLast"];
        // if (pageLast === false) {
        //     return "hide";
        // }

        return "show";
    }
    tabsRef: any;
    renderAct() {
        const { uiItem, dataSource, data, children, distanceToChangeTab = "1", tabBarSize, isData, className, loading, ...other } = this.props;
        const tabs = this.getTabs();
        const tabsInfo = Array.isArray(tabs) ? tabs : tabs ? [tabs] : [];
        const pageLast = this.props["pageLast"];
        return this.panel((context: IPanelContext) => {
            return (
                <div className={`react-tabs ${className} react-all-hide-${pageLast === false}  react-tabs-${this.getIsHide()}`} style={this.getStyle()}>
                    <AntTabs
                        {...other}
                        ref={(ref) => {
                            this.tabsRef = ref;
                        }}
                        onChange={this.onTabClick}
                        // onTabClick={this.onTabClick}
                        tabs={tabsInfo}
                        renderTabBar={this.renderTabBar.bind(this, context)}
                        distanceToChangeTab={Number(distanceToChangeTab)} //滑动切换阈值(宽度比例)
                    >
                        {this.renderContent.bind(this, context)}
                    </AntTabs>
                </div>
            );
        });
    }
}

export default Tabs;
